module.exports = __webpack_public_path__ + "static/media/icon-cart-enabled.a556543e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/add-to-cart-section/add-to-cart-button/icon-cart-enabled.svg
// module id = 895
// module chunks = 1